<div class="w-auto p-16-px">
  <div class="d-flex justify-space-between align-items-center h-32">
    <span class="subtitle-card text-size-18 text-color-white">
      Situación
    </span>
    <a class="serch subtitle-card text-size-16 text-weight-600 cursor-pointer" (click)="cleanFilter()">
      Limpiar
    </a>
  </div>

  <div class="filters">
    <button class="button-filter" [class.buttonSelected]='filters.situationIds[situationTypeFilterEnum.Incidente]'
      (click)="buildButtonsFilter('situationIds', situationTypeFilterEnum.Incidente)">Incidente</button>
    <button class="button-filter" [class.buttonSelected]='filters.situationIds[situationTypeFilterEnum.Evento]'
      (click)="buildButtonsFilter('situationIds', situationTypeFilterEnum.Evento)">Evento</button>
  </div>
  <span class="subtitle-card text-size-18 text-color-white">
    Estado
  </span>
  <div class="filters">
    <button class="button-filter" [class.buttonSelected]='filters.stateIds[situationStateFilterEnum.Abierto]'
      (click)="buildButtonsFilter('stateIds', situationStateFilterEnum.Abierto)">Abierto</button>
    <button class="button-filter" [class.buttonSelected]='filters.stateIds[situationStateFilterEnum.Cerrado]'
      (click)="buildButtonsFilter('stateIds', situationStateFilterEnum.Cerrado)">Cerrado</button>
    <button class="button-filter" [class.buttonSelected]='filters.stateIds[situationStateFilterEnum.Programado]'
      (click)="buildButtonsFilter('stateIds', situationStateFilterEnum.Programado)">Programado</button>
  </div>
  <div class="mt-24 filters-select">
    <mat-form-field appearance="outline">
      <mat-label>Categoría</mat-label>
      <mat-select (selectionChange)="onCategorySelected($event)" [(value)]="filters.categoryName">
        <mat-option *ngFor="let category of filterCategoryOptions" [value]="category">{{ category }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <span class="subtitle-card text-size-18 text-color-white">
    Prioridad
  </span>
  <div class="filters mb-12">
    <button class="button-filter" [class.buttonSelected]='filters.priorityIds[situationPriorityFilterEnum.Alta]'
      (click)="buildButtonsFilter('priorityIds', situationPriorityFilterEnum.Alta)">Alta</button>
    <button class="button-filter" [class.buttonSelected]='filters.priorityIds[situationPriorityFilterEnum.Media]'
      (click)="buildButtonsFilter('priorityIds', situationPriorityFilterEnum.Media)">Media</button>
    <button class="button-filter" [class.buttonSelected]='filters.priorityIds[situationPriorityFilterEnum.Baja]'
      (click)="buildButtonsFilter('priorityIds', situationPriorityFilterEnum.Baja)">Baja</button>
  </div>
  <div class=" mt-18 pr-16">
    <mat-form-field appearance="outline">
      <mat-label>Fecha y hora inicio*</mat-label>
      <input class="no-pad" matInput [(ngModel)]="filters.defaultDateStart" [ngxMatDatetimePicker]="pickerDateStart" />
      <mat-datepicker-toggle matSuffix [for]="$any(pickerDateStart)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #pickerDateStart [showSeconds]="true">
      </ngx-mat-datetime-picker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Fecha y hora final*</mat-label>
      <input matInput [(ngModel)]="filters.defaultDateEnd" [ngxMatDatetimePicker]="pickerDateEnd" />
      <mat-datepicker-toggle matSuffix [for]="$any(pickerDateEnd)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #pickerDateEnd [showSeconds]="true">
      </ngx-mat-datetime-picker>
    </mat-form-field>
  </div>
  <div class="footer-buttons">
    <button class="button-apply" (click)="applyFilter()">APLICAR</button>
  </div>
</div>
